export enum InviteInputType {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Mobile = 'mobile',
  Title = 'title',
  CompanyName = 'companyName',
  CompanyNumber = 'companyNumber',
}
